import React from "react";
import { useHistory } from "react-router-dom";
import { useSetupStatus } from "./useSetupStatus";

export default function ManageNodesSetupBanner({ hasManageUserGroups }) {
  const history = useHistory();
  const { loading, setupComplete } = useSetupStatus();

  if (!hasManageUserGroups || loading || setupComplete) return null;

  const goToUserGroups = (e) => {
    e.preventDefault();
    history.push("/manage-usergroup");
  };

  return (
    <div
      style={{
        background: "#fff8e1",
        borderLeft: "3px solid #f0b429",
        padding: 10,
        borderRadius: 4,
        fontSize: 12,
        color: "#444",
        marginBottom: 12,
      }}
    >
      <strong>Setup incomplete.</strong> To deploy nodes, you need a non-admin
      user group with operational permissions.
      <div style={{ marginTop: 6, fontSize: 11 }}>
        1.{" "}
        <a href="#" style={{ color: "#25AFA8" }} onClick={goToUserGroups}>
          Create user group →
        </a>
        &nbsp;&nbsp; 2. Add a user &nbsp;&nbsp; 3. Come back to add nodes
      </div>
    </div>
  );
}
